import { DemurrageDetentionStatusEnum } from '../../monitoring/models';
import { DateWithTimezones } from '../../../../common/models/status-history-chain.model';

export class ShipmentWaybillDemurrageAndDetentionAddress {
  name: string | null;
  address: string | null;
}

export class ShipmentWaybillDemurrageAndDetention {
  summary: ShipmentWaybillDemurrageAndDetentionSummary;
  origin: ShipmentWaybillDemurrageAndDetentionContainer;
  destination: ShipmentWaybillDemurrageAndDetentionContainer;
}

export class ShipmentWaybillDemurrageAndDetentionSummary {
  carrier: string;
  hbl: string;
  consignor: string;
  consignee: string;
  gb: string;
  origin: string;
  actualVesselDeparture: DateWithTimezones;
  estimatedVesselDeparture: DateWithTimezones;
  originDetentionFreeDays: number;
  originDetentionCost: number;
  originDemurrageFreeDays: number;
  originDemurrageCost: number;
  destination: string;
  actualVesselArrival: DateWithTimezones;
  estimatedVesselArrival: DateWithTimezones;
  destinationDetentionCost: number;
  destinationDetentionFreeDays: number;
  destinationDemurrageFreeDays: number;
  destinationDemurrageCost: number;
  totalContainers: number;
  totalCost: number;
  totalCostStatus: DemurrageDetentionStatusEnum;
  currency: string;
}

export class ShipmentWaybillDemurrageAndDetentionContainer {
  address: ShipmentWaybillDemurrageAndDetentionAddress;
  containers:
    | ShipmentWaybillDemurrageAndDetentionOriginContainer[]
    | ShipmentWaybillDemurrageAndDetentionDestinationContainer[];
}

export class ShipmentWaybillDemurrageAndDetentionOriginContainer {
  emptyContainerPickUp: DateWithTimezones;
  receivedOriginYard: DateWithTimezones;
  fullContainerLoaded: DateWithTimezones;
  container: string;
  detentionDays: number;
  detentionRemainingDays: number;
  detentionCost: number;
  detentionStatus: DemurrageDetentionStatusEnum;
  demurrageDays: number;
  demurrageRemainingDays: number;
  demurrageCost: number;
  demurrageStatus: DemurrageDetentionStatusEnum;
}

export class ShipmentWaybillDemurrageAndDetentionDestinationContainer {
  fullContainerDischarge: DateWithTimezones;
  gateOut: DateWithTimezones;
  emptyContainerReturned: DateWithTimezones;
  container: string;
  detentionDays: number;
  detentionRemainingDays: number;
  detentionCost: number;
  detentionStatus: DemurrageDetentionStatusEnum;
  demurrageDays: number;
  demurrageRemainingDays: number;
  demurrageCost: number;
  demurrageStatus: DemurrageDetentionStatusEnum;
}
